export function isVATExempt(billing) {
    return !!(billing && (billing.WorldVATWithoutCharge || billing.EUVATReverseCharge));
}

export function getPricingBillingAddress(user, selectedAddressId = null) {
    if (!user || !user.logged) {
        return null;
    }
    const addresses = user.addresses || [];
    const preferredId = user.preferences && user.preferences.billing && user.preferences.billing.addressId;
    const findAddress = id => id && addresses.find(address => String(address._id) === String(id));
    return findAddress(selectedAddressId) || findAddress(preferredId) || (addresses.length === 1 ? addresses[0] : null);
}

export function isUserVATExempt(user, config, selectedAddressId = null) {
    const address = getPricingBillingAddress(user, selectedAddressId);
    return !!address && isOrderVATExempt({ billing: { address } }, config, null, user);
}

export function isOrderVATExempt(order, config = {}, review = null, user = {}) {
    if (review) {
        return isVATExempt(review.billing);
    }
    if (order.createdAt || order._id) {
        return isVATExempt(order.billing);
    }
    const rules = config.shop && config.shop.worldVATWithoutCharge;
    const euRules = config.shop && config.shop.euVATReverseCharge;
    const address = order.billing && order.billing.address;
    if (!address) {
        return isVATExempt(order.billing);
    }
    const iso = address.country && address.country.iso ? address.country.iso.toUpperCase() : "";
    const zipCode = address.zipCode ? address.zipCode.replace(/\s/g, "") : "";
    const worldExempt = rules && (rules.countries.includes(iso) || rules.zipCodePrefixes.some(prefix => zipCode.startsWith(prefix)));
    const euExempt = euRules && euRules.enabled && user.isProfessional && address.vatin && euRules.countries.includes(iso);
    return isVATExempt(order.billing) || !!worldExempt || !!euExempt;
}

export function getProductTotal(product, withoutVAT = false) {
    if (Number.isFinite(product.totalWT)) {
        return withoutVAT ? product.total : product.totalWT;
    }
    const price = getProductUnitPrice(product, withoutVAT, true);
    const paidOnce = ["assisted-product-creation", "product-creation-workshop", "physical-printing-approval"];
    return price * product.quantity + (product.options || []).reduce((total, option) => {
        if (!option.charge || product.alreadyOrdered && paidOnce.includes(option.name)) {
            return total;
        }
        return total + (withoutVAT ? option.charge.price : option.charge.priceWT);
    }, 0);
}

export function getProductUnitPrice(product, withoutVAT = false, discounted = false, currencies) {
    const price = discounted ? product.discountedPriceWT : product.priceWT;
    if (!withoutVAT) {
        return price;
    }
    if (!discounted) {
        return product.price;
    }
    // Catalogue responses may omit discountedPrice when no quantity was requested.
    const percent = product.tax && product.tax.percent || 0;
    const currency = currencies && currencies.find(currency => currency.alpha3ISO === product.currency);
    return Number((price / (1 + percent / 100)).toFixed(currency ? currency.decimalDigits : 2));
}

export function getWithdrawalPointPrice(withdrawalPoint, products, deliveryTaxes, withoutVAT, currencies) {
    if (!withoutVAT) {
        return withdrawalPoint.priceWT;
    }
    const reducedTotal = products.filter(product => product.tax.reduced).reduce((total, product) => total + getProductTotal(product), 0);
    const fullTotal = products.filter(product => !product.tax.reduced).reduce((total, product) => total + getProductTotal(product), 0);
    const percent = fullTotal < reducedTotal ? deliveryTaxes.reduced : deliveryTaxes.full;
    const currency = currencies && currencies.find(currency => currency.alpha3ISO === withdrawalPoint.currency);
    const decimalDigits = currency ? currency.decimalDigits : 2;
    return Number((withdrawalPoint.priceWT / (1 + percent / 100)).toFixed(decimalDigits));
}